import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";
import Loading from "shared/components/Loading";
import ListHeader from "components/ListHeader";
import VideoDescriptionItem from "components/VideoDescriptionItem";
import Button from "shared/components/buttons/Button";
import { sortByOrderType } from "helpers/sortByOrderType";
import { fetchVideoDescriptionsAction } from "redux/actions/fetchVideoDescriptionsAction";
import "./style.scss";

const HEADERS = [
    { field: "title", label: "Title" },
    { field: "published", label: "Publish Status" },
    { field: "description", label: "Description" }
];

export default function VideoDescriptions() {
    const [t] = useTranslation();
    const dispatch = useDispatch();
    const history = useHistory();

    const [sortIndex, setSortIndex] = useState(0);
    const [sortDirection, setSortDirection] = useState(false);

    const { videoDescriptions, loading } = useSelector(state => state.video);

    useEffect(() => {
        dispatch(fetchVideoDescriptionsAction());
    }, [dispatch]);

    const hasVideoDescriptions = () => {
        return Array.isArray(videoDescriptions) && videoDescriptions.length > 0;
    };

    const sortItems = (items) => {
        return Array.isArray(items) && items.length > 0 && sortIndex >= 0
            ? sortByOrderType(HEADERS, items, sortIndex, sortDirection)
            : items;
    };

    const onSort = (idx) => {
        setSortDirection(!sortDirection);
        setSortIndex(idx);
    };

    const renderEmptyState = () => {
        return (
            <div className="container-empty">
                No video descriptions found.
            </div>
        );
    };

    const renderVideoDescriptionItems = () => {
        const sortedItems = sortItems(videoDescriptions);
        return sortedItems.map((item, index) => {
            return (
                <VideoDescriptionItem
                    key={item?.id || index}
                    item={item}
                />
            );
        });
    };

    const renderVideoDescriptions = () => {
        if (hasVideoDescriptions()) {
            return renderVideoDescriptionItems();
        } else if (!loading) {
            return renderEmptyState();
        }
    };

    const renderListHeader = () => {
        return Array.isArray(videoDescriptions) && videoDescriptions.length > 0 && (
            <ListHeader
                onSort={onSort}
                items={HEADERS}
                sortIndex={sortIndex}
                sortDirection={sortDirection}
            />);
    };

    return (
        <div className="organisation-overview">
            <div className="overview-header">
                <h2>{t("admin.video.introductions")}</h2>
                <Button
                    label="Add Video Description"
                    onClick={() => history.push("/videos/new/edit")}
                />
            </div>

            <div className="spacer" />
            <div className="filter-divider" />
            <div className="spacer-double" />

            {loading ?
                <Loading /> :
                <>
                    {renderListHeader()}
                    <div className="organisation-list-items">
                        {renderVideoDescriptions()}
                    </div>
                </>
            }
        </div>
    );
}
